import React from 'react';
import { AppBar, UserMenu } from 'react-admin';
import { Typography } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import Logo from './Logo';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { LOGOUT_URL } from '../Constants/index';

export const CustomAppBar = () => {
    const [open, setOpen] = React.useState(false);

    //const logout = useLogout();
    const logout = () => {
        localStorage.removeItem('auth-token');
        localStorage.removeItem('uinf');
        localStorage.removeItem('username');
        window.location.href = LOGOUT_URL;
        setOpen(true);
    };

    const MyUserMenu = () => (
        <UserMenu>
            <MenuItem disabled={true}>{localStorage.getItem("username")}</MenuItem>
            <MenuItem onClick={logout}><LogoutIcon sx={{ paddingRight: '1rem' }} />Logout</MenuItem>
        </UserMenu>
    );

    return (
        <AppBar userMenu={<MyUserMenu />} >
            <Typography
                variant="title"
                color="inherit"
                id="react-admin-title"
                sx={{
                    flex: 1,
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden'
                }}
            />
            <Logo />
            <Box sx={{ flex: 1 }} >
                <span />
            </Box>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </AppBar>
    )
};